import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./deslocamentos.component.html')
})
export class DeslocamentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamentos.component.ts
 **/